import type { DateString } from "seedgreen-shared/types/datestring.types";
import type { Dayjs, PluginFunc } from "dayjs";

/** Plugin for dayjs that creates a properly typed DateString */
const toDateStringPlugin: PluginFunc = (_option, dayjsClass) => {
	dayjsClass.prototype.toDateString = function (this: Dayjs): DateString {
		return this.format("YYYY-MM-DD") as DateString;
	};
};

export default toDateStringPlugin;

// TypeScript Module Augmentation:
declare module "dayjs" {
	interface Dayjs {
		toDateString(): DateString;
	}
}
